import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../vessel-reg/confirm-dialog/confirm-dialog.component';
import { VesselData } from '../vessel-reg/vessel-data.model';

export interface DialogData {
  mothership: boolean;
  vessel: VesselData;
  edit: boolean;
}

/**
 * Dialog to add a new vessel, either from settings or vessel-reg
 */
@Component({
    selector: 'app-add-vessel-dialog',
    templateUrl: './add-vessel-dialog.component.html',
    styleUrls: ['./add-vessel-dialog.component.css'],
    standalone: false
})
export class AddVesselDialogComponent implements OnInit {

  dialogReturn: VesselData = new VesselData('', '');

  form = new FormGroup({
    vesselName: new FormControl('', [Validators.required, Validators.pattern('^[A-z0-9 ]+$')]),
    vesselNumber: new FormControl('', [Validators.required, Validators.pattern('^([0-9]{6}|[A-z0-9]{7,8})$')])
  });

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AddVesselDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }

  ngOnInit(): void {
    if (this.data.vessel != null) {
      this.form.patchValue({
        vesselName: this.data.vessel.vesselName,
        vesselNumber: this.data.vessel.vesselCoastNumber
      });
    }

    if (this.data.mothership) {
      this.form.get('vesselNumber')?.clearValidators();
      this.form.get('vesselNumber')?.updateValueAndValidity();
    }
  }

  // add entered vessel
  addVessel(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }    
  }

  // delete selected vessel
  deleteVessel(): void {
    if (this.data == null) this.dialogRef.close('delete'); 
    else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {screen: 'deletevessel'},
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result)
        this.dialogRef.close('delete'); 
      });
    }
  }

  cancelVessel(): void {
    this.dialogRef.close('delete'); 
  }

}
